import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {MessageService} from 'primeng/api';
import {ShipmentInstructionService} from '../../@shared/new-services/shipment-instruction.service';
import {FileUpload} from 'primeng/fileupload';
import {Observable} from 'rxjs';

@Component({
    selector: 'container-details',
    templateUrl: './container-details.component.html',
    styleUrls: ['./container-details.component.scss']
})
export class ContainerDetailsComponent implements OnInit {

    @Input() siAction = 'add';

    @Input() isPreviewSI = false;
    containerDetailsForm: FormArray = new FormArray([]);
    @Input() siContainers: any[] = [];
    @Input() shipmentType: string;
    @Output() emitContainerDetails: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitSiDocuments: EventEmitter<any> = new EventEmitter<any>();

    filteredCommodities: any;
    commodities: any;
    kindOfPackages: any;
    weightUnit: any[] = ['KG', 'LBS'];
    measureUnit: any[] = ['FT'];
    containerTypesArray: any[] = [
        {containerId: 'General', containerDescription: 'General'},
        {containerId: 'Hazardous', containerDescription: 'Hazardous'},
        {containerId: 'Reefer', containerDescription: 'Reefer'},
        {containerId: 'ODC', containerDescription: 'ODC - (Over Dimension Cargo)'}
    ];

    constructor(private shipmentInstructionService: ShipmentInstructionService,
                private messageService: MessageService) {
    }

    ngOnInit(): void {
        this.getKindOfPackages();
        this.siContainers?.map((siContainer) => {
            this.addSiContainerDetail(siContainer);
        });
    }

    getCommodities(prefix: string) {
        this.shipmentInstructionService
            .getCommodities(prefix)
            .subscribe((commodities) => {
                this.commodities = commodities;
            });
    }

    completeCommodities(event: any) {
        const filtered: any[] = [];
        const query = event.query;

        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.commodities?.length; i++) {
            const commodity = this.commodities[i];
            if (commodity.commodityDescription.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(commodity);
            }
        }

        this.filteredCommodities = filtered;
    }

    getCommoditiesByPrefix(event: any) {
        const prefix = event?.target.value;

        if (prefix?.length >= 3) {
            this.getCommodities(prefix);
            return;
        }
    }

    getKindOfPackages() {
        this.shipmentInstructionService
            .getKindOfPackages()
            .subscribe((kindOfPackages) => {
                this.kindOfPackages = kindOfPackages;
            });
    }

    presentToastMessage(severity, detail) {
        this.messageService
            .add(
                {
                    severity,
                    summary: 'Cargo Details Message !',
                    key: 'cargo-details-message',
                    detail,
                }
            );
    }

    emitContainerDetailsValue() {
        const siContainers = this.containerDetailsForm.value;
        // const validations = siContainers?.map((x, i) => {
        //
        //     if (x?.commodity || x?.commodity?.length === 0) {
        //         if (!x.commodity.commodityCode || !x.commodity.commodityDescription) {
        //             this.messageService.add({
        //                 key: 'si-messages',
        //                 severity: 'error',
        //                 summary: 'Save SI Error !',
        //                 detail: 'Invalid Commodity, Please select valid Commodity from dropdown at Form Number : ' + (i + 1) + ' !',
        //             });
        //             const containerDetailsForm = this.getFormGroup(i);
        //             containerDetailsForm.controls.commodity.setValue(null);
        //             return false;
        //         } else {
        //         }
        //         return false;
        //     }
        //     return true;
        // });
        // if (validations.includes(false)) {
        //     return;
        // }
        this.emitContainerDetails
            .emit(siContainers);
    }

    emitSiDocumentsForUpload(documentTypeId: any, event: any, cargoDetails: any, fileUploadComponent: FileUpload) {
        const files = event?.files;
        this.emitSiDocuments.emit(
            {
                files,
                documentTypeId,
                cargoDetails,
                fileUploadComponent
            }
        );
    }

    getDocumentByDocumentTypeId(siContainerDocuments: any, documentTypeId: string): any {
        const containerDocument: Observable<any> = siContainerDocuments?.map((document) => {
            if (document?.documentTypeId === documentTypeId) {
                document.name = document?.name ? document?.name : 'File Name is Empty';
                return document as Observable<any>;
            }
        });
        return containerDocument[0];
    }

    addSiContainerDetail(siContainer?: any) {
        const siContainerDetail: FormGroup = new FormGroup({

            // Common fields for All Shipment Types
            bookingId: new FormControl(siContainer?.bookingId ? siContainer?.bookingId : null),
            shipUnitId: new FormControl(siContainer?.shipUnitId ? siContainer?.shipUnitId : this.isPreviewSI),
            cargoType: new FormControl(
                siContainer?.cargoType ? siContainer?.cargoType : 'General'
            ),
            length: new FormControl({
                value: siContainer?.length ? siContainer?.length : '', disabled: this.isPreviewSI
            }),
            lengthUOM: new FormControl({
                value: siContainer?.lengthUOM ? siContainer?.lengthUOM : 'FT', disabled: this.isPreviewSI
            }),
            width: new FormControl({
                value: siContainer?.width ? siContainer?.width : '', disabled: this.isPreviewSI
            }),
            widthUOM: new FormControl({value: siContainer?.widthUOM ? siContainer?.widthUOM : 'FT', disabled: this.isPreviewSI}),
            height: new FormControl({value: siContainer?.height ? siContainer?.height : '', disabled: this.isPreviewSI}),
            heightUOM: new FormControl({value: siContainer?.heightUOM ? siContainer?.heightUOM : 'FT', disabled: this.isPreviewSI}),
            // TODO: To check with BackEnd Service weather this requires or not CommodityObj.
            commodityObj: new FormControl(siContainer?.commodityObj ?
                siContainer?.commodityObj : null),
            commodity: new FormControl({
                value: siContainer?.commodity ? siContainer?.commodity : null, disabled: this.isPreviewSI
            }),
            kindOfPackage: new FormControl({
                value: siContainer?.kindOfPackage ? siContainer?.kindOfPackage : null,
                disabled: this.isPreviewSI
            }),
            numberOfPackage: new FormControl({
                value: siContainer?.numberOfPackage ? siContainer?.numberOfPackage : null,
                disabled: this.isPreviewSI
            }),
            volume: new FormControl({value: siContainer?.volume ? siContainer?.volume : null, disabled: this.isPreviewSI}),
            volumeUOM: new FormControl({value: 'CBM', disabled: this.isPreviewSI}),
            grossWeight: new FormControl({value: siContainer?.grossWeight ? siContainer?.grossWeight : null, disabled: this.isPreviewSI}),
            grossWeightUOM: new FormControl({
                value: siContainer?.grossWeightUOM ? siContainer?.grossWeightUOM : 'KG', disabled: this.isPreviewSI
            }),
            imcoClass: new FormControl({value: siContainer?.imcoClass ? siContainer?.imcoClass : null, disabled: this.isPreviewSI}),
            unNumber: new FormControl({value: siContainer?.unNumber ? siContainer?.unNumber : null, disabled: this.isPreviewSI}),
            temperature: new FormControl({
                value: siContainer?.temperature ? siContainer?.temperature : null, disabled: this.isPreviewSI
            }),
            temperatureUOM: new FormControl('C'),

            // Documents Related Payload
            containerDocuments: new FormControl(siContainer?.containerDocuments ? siContainer?.containerDocuments : []),

            // Field of FCL/LCL Shipment Type
            containerSubTypeDescription: new FormControl(
                siContainer?.containerSubTypeDescription ? siContainer?.containerSubTypeDescription : ''
            ),
            containerSubType: new FormControl(
                siContainer?.containerSubType ? siContainer?.containerSubType : '',
            ),
            containerNumber: new FormControl({
                value: siContainer?.containerNumber ? siContainer?.containerNumber : '', disabled: this.isPreviewSI
            }),
            sealNumber: new FormControl({
                value: siContainer?.sealNumber ? siContainer?.sealNumber : '', disabled: this.isPreviewSI
            }),
            netWeight: new FormControl({
                value: siContainer?.netWeight ? siContainer?.netWeight : '', disabled: this.isPreviewSI
            }),
            netWeightUOM: new FormControl({
                value: siContainer?.netWeightUOM ? siContainer?.netWeightUOM : 'KG', disabled: this.isPreviewSI
            }),
            vgmWeight: new FormControl({
                value: siContainer?.vgmWeight ? siContainer?.vgmWeight : '', disabled: this.isPreviewSI
            }),
            vgmWeightUOM: new FormControl({
                value: siContainer?.vgmWeightUOM ? siContainer?.vgmWeightUOM : 'KG', disabled: this.isPreviewSI
            }),
            humidity: new FormControl({
                value: siContainer?.humidity ? siContainer?.humidity : '', disabled: this.isPreviewSI
            }),
            ventilation: new FormControl({
                value: siContainer?.ventilation ? siContainer?.ventilation : '', disabled: this.isPreviewSI
            }),
            ventilationUOM: new FormControl({value: 'CMH', disabled: this.isPreviewSI}),
            weightInTonnes: new FormControl({
                value: siContainer?.weightInTonnes
                    ? siContainer?.weightInTonnes : null, disabled: this.isPreviewSI
            }),

            // Field of AIR Shipment Type
            cageLength: new FormControl(null),
            cageLengthUOM: new FormControl(null),
            cageWidth: new FormControl(null),
            cageWidthUOM: new FormControl(null),
            cageHeight: new FormControl(null),
            cageHeightUOM: new FormControl(null),
            chargeableWeight: new FormControl(null),
            chargeableWeightUOM: new FormControl(null),
            wheelBaseDimension: new FormControl(null),
            typeOfUnPacking: new FormControl(null),

            // Container Documents
            vgmDocument: new FormControl(siContainer?.vgmDocument ? siContainer?.vgmDocument : null),
            liveAnimalDocument: new FormControl(siContainer?.liveAnimalDocument ? siContainer?.liveAnimalDocument : null),
            msdsDocument: new FormControl(siContainer?.msdsDocument ? siContainer?.msdsDocument : null),
            ataCarnetDocument: new FormControl(siContainer?.ataCarnetDocument ? siContainer?.ataCarnetDocument : null),
        });

        // @ts-ignore
        this.containerDetailsForm.push(siContainerDetail);
    }

    private getFormGroup(i: number): FormGroup {
        const containerDetailsForm: FormGroup = this.containerDetailsForm.at(i) as FormGroup;
        return containerDetailsForm;
    }

}
